import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qqvkwetda4: FaireBrandEntity = {
  token: "b_qqvkwetda4",
  type: "brand",
  name: "Madi Moosh",
  avatarUrl:
    "https://cdn.faire.com/fastly/a0e064fd38fe83397e71ba5ba4245e4b59d8a5aff31746380c42de90d3acc894.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d7b0a6e0d97dd49aae2c1ccdbcb780f5e691a876258e62daf7b15eebd0362bbe.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a0e064fd38fe83397e71ba5ba4245e4b59d8a5aff31746380c42de90d3acc894.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d7b0a6e0d97dd49aae2c1ccdbcb780f5e691a876258e62daf7b15eebd0362bbe.png",
  location: "Edmond, OK, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 65,
  isTopShop: true,
  isInsider: true,
  description:
    "We’re Mark and Tracy — proud partners in life and business. Married for 30 years, we’ve raised three amazing kids and now enjoy one sweet grandbaby. The story of Madi Moosh began three decades ago with our daughter, Madison. Her very first word was “moosh” (her version of “move”), and from that day forward, she was lovingly nicknamed Madi Moosh. Without knowing it, our brand name was born.\n\nBased in Edmond, Oklahoma, we are a true family-owned business with more than 35 years of experience in printing and design. What started as a nickname has grown into a passion: creating fun, custom designs on super-soft, high-quality tees for all ages. Every shirt is DTG printed with eco-friendly, non-toxic inks.\n\nWe believe in keeping things personal, creative, and comfortable — and we’re so thankful for every customer who supports our small business. ♡\n\nA quick note about printing:\nBecause we use DTG printing instead of vinyl, our designs won’t have the same glossy shine you may see with vinyl prints. Instead, they offer a soft finish that won’t crack or peel over time. Please note that print colors may vary slightly due to differences in your phone, tablet, or computer screen.\n\nAll images and designs are the property of MADI MOOSH LLC. \n© 2025 MADI MOOSH LLC. All rights reserved.\nDO NOT COPY ANY IMAGES!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:22.861Z",
    importedBy: "entity-db-cli",
  },
};
